module.exports = __webpack_public_path__ + "images/marketing/peeps/likes/jennifer_rideout_redeker.jpg";